export const api = {
  ALLOW_LIST_PROOF: '/users/allowlist_proof',
}
